import { render, staticRenderFns } from "./news24.vue?vue&type=template&id=0cc87502&"
import script from "./news24.vue?vue&type=script&lang=js&"
export * from "./news24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports